// The startup screens take turns: the update check (UpdateGate.tsx) first, then the warm-up on the
// same screen (shell/warmup/), then the audio download (AudioGate.tsx). The audio screen waits while
// an update is being looked for or installed (a found version reloads the page, and the new build's
// audio list is the one to download) and while the warm-up runs.

let updateBusy = false;
const listeners = new Set<() => void>();

/** UpdateGate: its screen is up (checking or updating) or gone. */
export function setUpdateGateBusy(busy: boolean): void {
  if (busy === updateBusy) return;
  updateBusy = busy;
  for (const l of listeners) l();
}

export const updateGateBusy = (): boolean => updateBusy;

export function onUpdateGateChange(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

// ---- the warm-up (shell/warmup/): after the update check, before the audio download ----
// main.tsx arms it before the first render (so the loading screen is up from the first frame),
// UpdateGate.tsx starts it once the update check is over (a found version reloads the page first)
// and shows its steps on the same screen; AudioGate.tsx waits until it is over. Off (never armed)
// in unit tests. onUpdateGateChange also tells of its changes.

export type WarmupState = 'off' | 'armed' | 'running' | 'done';

export interface WarmupView {
  state: WarmupState;
  /** The running step's label (a key of the i18n area `warmup`), null before the first step. */
  label: string | null;
  /** 0..1 over all steps. */
  fraction: number;
}

let warm: WarmupView = { state: 'off', label: null, fraction: 0 };

export function setWarmupView(v: WarmupView): void {
  warm = v;
  for (const l of listeners) l();
}

export const warmupView = (): WarmupView => warm;

/** The update check's or the warm-up's screen is up: the audio download's screen waits. */
export const startupBusy = (): boolean => updateBusy || warm.state === 'armed' || warm.state === 'running';

/** The warm-up is over (or never ran): the audio download may start. */
export const warmupOver = (): boolean => warm.state === 'off' || warm.state === 'done';
